module.exports = __webpack_public_path__ + "img/robust.acf4890a.svg";